import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/GuestMaster.css";
import function1 from "../../assets/images/function1.svg";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
// import * as XLSX from "xlsx";
import * as XLSX from "sheetjs-style";

import {
  addGuest,
  updateGuest,
  deleteGuest,
  importGuestsAndAttendees,
  downloadGuestTemplate,
} from "../../server/Api";
import { getLookupUtils } from "../../utils/lookup";
import { getMainGuestByEventId } from "../../utils/getMainGuest";
import { getMainGuestsAndAttendees } from "../../utils/getGuestWithAttendees";
import axios from "axios";
import { canEditPage, canDeletePage } from "../../utils/pagePermissions";
import {
  validateRequiredFields,
  firstErrorMessage,
  focusFirstInvalidField,
} from "../../utils/formValidation";
import { getAuthToken } from "../../utils/authToken";
import {
  countGuestAttendees,
  eventPeopleCapacityMessage,
  capacityApiMessage,
  sumOccasionCapacities,
} from "../../utils/capacityLimits";
import { useEventCapacity } from "../../utils/useEventCapacity";
import CapacityNoticeModal from "../../components/CapacityNoticeModal";
import { getAllOccasions } from "../../utils/getAllOccasions";

const GuestMaster = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeStep, setActiveStep] = useState(1);
  const [activeTab, setActiveTab] = useState("guestList");
  const [prefixDropdown, setPrefixDropdown] = useState([]);
  const [suffixDropdown, setSuffixDropdown] = useState([]);
  const [stateDropdown, setStateDropdown] = useState([]);
  const [countryDropdown, setCountryDropdown] = useState([]);
  const [foodPreference, setFoodPreference] = useState([]);
  const [guests, setGuests] = useState([]);
  const [guestWithAttendees, setGuestWithAttendees] = useState([]);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingGuestId, setEditingGuestId] = useState(null);
  const [importModal, setImportModal] = useState({
    isOpen: false,
  });
  const selectedEvent = useSelector((state) => state.auth.selectedEvent);
  const eventEntity = useSelector((state) => state.auth.user);
  const canEdit = canEditPage(selectedEvent, "guest-master", eventEntity);
  const canDelete = canDeletePage(selectedEvent, "guest-master", eventEntity);
  const [capacityNotice, setCapacityNotice] = useState(null);
  const { eventCapacity } = useEventCapacity(selectedEvent?.eventId);
  const [occasions, setOccasions] = useState([]);
  const peopleCount = countGuestAttendees(guestWithAttendees);
  const combinedOccasionCapacity = sumOccasionCapacities(occasions);
  const peopleCapCandidates = [
    eventCapacity,
    combinedOccasionCapacity > 0 ? combinedOccasionCapacity : null,
  ].filter((value) => value != null);
  const peopleCap = peopleCapCandidates.length
    ? Math.min(...peopleCapCandidates)
    : null;
  const navigate = useNavigate();
  const initialGuestData = {
    eventId: "",
    prefix: "",
    firstName: "",
    MiddleName: "",
    lastName: "",
    suffix: "",
    gender: "",
    alternateMobileNo: "",
    email: "",
    mobileNo: "",
    addressType: "",
    companyName: "",
    designation: "",
    address: {
      line1: "",
      line2: "",
      line3: "",
      city: "",
      state: "",
      pincode: "",
      country: "",
    },
    foodPreference: "",
    allergic: "",
    specialNeeds: "",
    specialRequest: "",
    enteredBy: "",
  };

  const [guestData, setGuestData] = useState(initialGuestData);
  const [fieldErrors, setFieldErrors] = useState({});

  const [deleteConfirmation, setDeleteConfirmation] = useState({
    isOpen: false,
    guestId: null,
    guestName: "",
  });

  const handleAddAttendee = (guest) => {
    navigate("/guest-attendee", {
      state: { mainGuestId: guest._id },
    });
  };

  const getAllGuestByEventId = async () => {
    try {
      if (!selectedEvent?.eventId) return;

      const guestsData = await getMainGuestByEventId(selectedEvent.eventId); // use the utility
      setGuests(guestsData);
      console.log("Guests fetched successfully:", guestsData);
    } catch (error) {
      console.error("Error fetching guests:", error);
      toast.error("Failed to fetch guests.");
    }
  };

  useEffect(() => {
    if (selectedEvent?.eventId) {
      getAllGuestByEventId();
      getAllOccasions(selectedEvent.eventId)
        .then(setOccasions)
        .catch(() => setOccasions([]));
    }
  }, [selectedEvent?.eventId]);

  useEffect(() => {
    if (activeTab === "guestList" && selectedEvent?.eventId) {
      getAllGuestByEventId();
    }
  }, [activeTab, selectedEvent?.eventId]);

  const getAllGuestWithAttendeesByEventId = async () => {
    try {
      if (!selectedEvent?.eventId) return;

      const data = await getMainGuestsAndAttendees(selectedEvent.eventId); // utility function
      setGuestWithAttendees(data);
      console.log("Guest & Attendee list fetched successfully:", data);
    } catch (error) {
      console.error("Error fetching guest & attendee list:", error);
      toast.error("Failed to fetch guest & attendee list.");
    }
  };

  useEffect(() => {
    if (selectedEvent?.eventId) {
      getAllGuestWithAttendeesByEventId();
    }
  }, [selectedEvent]);

  const handleGuestAndAttendeeExport = () => {
    if (!guestWithAttendees || guestWithAttendees.length === 0) {
      toast.error("No data available to export.");
      return;
    }

    try {
      const exportRows = [];

      const headers = [
        "Record Type",
        "Prefix",
        "First Name",
        "Middle Name",
        "Last Name",
        "Suffix",
        "Gender",
        "Relationship",
        "Attendee Type",
        "Mobile No.",
        "Alternate Mobile No.",
        "Email ID",
        "Food Preference",
        "Allergic",
        "Special Needs",
        "Special Request",
        "Address Type",
        "Company Name",
        "Designation",
        "Address Line 1",
        "Address Line 2",
        "Address Line 3",
        "City",
        "State",
        "Pincode",
        "Country",
      ];

      exportRows.push(headers);

      const rowStyles = []; // To track styles per row

      guestWithAttendees.forEach(({ guest, attendees }) => {
        const g = guest;

        // Guest row
        exportRows.push([
          "GUEST",
          g.prefix || "",
          g.firstName || "",
          g.MiddleName || "",
          g.lastName || "",
          g.suffix || "",
          g.gender || "",
          "",
          "",
          g.mobileNo || "",
          g.alternateMobileNo || "",
          g.email || "",
          g.foodPreference || "",
          g.allergic || "",
          g.specialNeeds || "",
          g.specialRequest || "",
          g.addressType || "",
          g.companyName || "",
          g.designation || "",
          g.address?.line1 || "",
          g.address?.line2 || "",
          g.address?.line3 || "",
          g.address?.city || "",
          g.address?.state || "",
          g.address?.pincode?.toString() || "",
          g.address?.country || "",
        ]);
        rowStyles.push({ type: "GUEST" });

        // Attendee rows
        attendees?.forEach((a) => {
          exportRows.push([
            "ATTENDEE",
            a.prefix || "",
            a.firstName || "",
            a.middleName || "",
            a.lastName || "",
            a.suffix || "",
            a.gender || "",
            a.relationWithMainMember || "",
            a.demographic || "",
            a.mobileNo || "",
            "",
            a.email || "",
            a.foodPreference || "",
            a.allergic || "",
            a.specialNeeds || "",
            a.specialRequest || "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
          ]);
          rowStyles.push({ type: "ATTENDEE" });
        });
      });

      const worksheet = XLSX.utils.aoa_to_sheet(exportRows);

      // Style header: bold + light green
      const headerCellStyle = {
        font: { bold: true },
        fill: { fgColor: { rgb: "19B0B0" } }, // Light green
      };
      headers.forEach((_, i) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
        if (!worksheet[cellRef]) return;
        worksheet[cellRef].s = headerCellStyle;
      });

      // Apply row-specific background colors
      rowStyles.forEach((rowStyle, rowIndex) => {
        const excelRowIndex = rowIndex + 1; // +1 because headers are at row 0

        const fillColor =
          rowStyle.type === "GUEST"
            ? "C7E2E3" // Light blue for guests
            : "ECF5F5"; // Light yellow for attendees

        for (let colIndex = 0; colIndex < headers.length; colIndex++) {
          const cellRef = XLSX.utils.encode_cell({
            r: excelRowIndex,
            c: colIndex,
          });

          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            fill: { fgColor: { rgb: fillColor } },
          };
        }
      });

      // Auto column widths
      const columnWidths = headers.map((_, colIndex) => {
        const maxLength = exportRows.reduce((max, row) => {
          const cell = row[colIndex];
          return Math.max(max, cell ? cell.toString().length : 10);
        }, 10);
        return { wch: maxLength + 2 };
      });
      worksheet["!cols"] = columnWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Guests");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "guest_export.xlsx";
      link.click();

      toast.success("Excel downloaded successfully!");
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Failed to export guest list.");
    }
  };

  // Runs when active tab is "guestAndAttendeeList"
  useEffect(() => {
    if (activeTab === "guestAndAttendeeList" && selectedEvent?.eventId) {
      getAllGuestWithAttendeesByEventId();
    }
  }, [activeTab, selectedEvent?.eventId]);

  // Run on event change to preload data
  useEffect(() => {
    if (selectedEvent?.eventId) {
      getAllGuestWithAttendeesByEventId();
    }
  }, [selectedEvent?.eventId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setGuestData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (fieldErrors[name]) {
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setGuestData((prev) => ({
      ...prev,
      address: { ...prev.address, [name]: value },
    }));
    if (fieldErrors[name]) {
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }
  };

  const getFieldClass = (baseClass, name) =>
    `${baseClass}${fieldErrors[name] ? " is-invalid" : ""}`;

  const renderFieldError = (name) =>
    fieldErrors[name] ? (
      <div className="invalid-feedback d-block">{fieldErrors[name]}</div>
    ) : null;

  const validateGuestForm = () => {
    const errors = validateRequiredFields([
      { key: "prefix", value: guestData.prefix, label: "Prefix" },
      { key: "firstName", value: guestData.firstName, label: "First Name" },
      { key: "MiddleName", value: guestData.MiddleName, label: "Middle Name" },
      { key: "lastName", value: guestData.lastName, label: "Last Name" },
      { key: "suffix", value: guestData.suffix, label: "Suffix" },
      { key: "mobileNo", value: guestData.mobileNo, label: "Mobile Number" },
      { key: "email", value: guestData.email, label: "Email" },
      { key: "line1", value: guestData.address?.line1, label: "Address Line 1" },
      { key: "city", value: guestData.address?.city, label: "City" },
      { key: "pincode", value: guestData.address?.pincode, label: "Pincode" },
    ]);

    if (
      guestData.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(guestData.email).trim())
    ) {
      errors.email = "Enter a valid email address";
    }

    if (
      guestData.mobileNo &&
      !/^\+?[\d\s-]{7,15}$/.test(String(guestData.mobileNo).trim())
    ) {
      errors.mobileNo = "Enter a valid mobile number";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateGuestForm();
    if (Object.keys(errors).length > 0) {
      setActiveStep(1);
      setFieldErrors(errors);
      toast.error(firstErrorMessage(errors));
      focusFirstInvalidField(errors, {
        rootSelector: "#guestForm",
        order: [
          "prefix",
          "firstName",
          "MiddleName",
          "lastName",
          "suffix",
          "mobileNo",
          "email",
          "line1",
          "city",
          "pincode",
        ],
      });
      return;
    }

    setFieldErrors({});

    if (!isEditing && peopleCap != null && peopleCount.total + 1 > peopleCap) {
      const isOccasionLimit =
        combinedOccasionCapacity > 0 && peopleCap === combinedOccasionCapacity;
      setCapacityNotice({
        title: isOccasionLimit
          ? "Cannot exceed occasion capacity"
          : "Cannot exceed event capacity",
        message: isOccasionLimit
          ? `Guests and attendees cannot exceed the combined occasion capacity of ${combinedOccasionCapacity}. ${peopleCount.total} ${
              peopleCount.total === 1 ? "person is" : "people are"
            } already added.`
          : eventPeopleCapacityMessage({
              eventCapacity: peopleCap,
              currentTotal: peopleCount.total,
              adding: 1,
            }),
      });
      return;
    }

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("eventId", selectedEvent?.eventId || "");
      formDataToSend.append("prefix", guestData.prefix || "");
      formDataToSend.append("firstName", guestData.firstName || "");
      formDataToSend.append("MiddleName", guestData.MiddleName || "");
      formDataToSend.append("lastName", guestData.lastName || "");
      formDataToSend.append("suffix", guestData.suffix || "");
      formDataToSend.append("gender", guestData.gender || "");
      formDataToSend.append(
        "alternateMobileNo",
        guestData.alternateMobileNo || ""
      );
      formDataToSend.append("email", guestData.email || "");
      formDataToSend.append("mobileNo", guestData.mobileNo || "");
      formDataToSend.append("addressType", guestData.addressType || "");
      formDataToSend.append("companyName", guestData.companyName || "");
      formDataToSend.append("designation", guestData.designation || "");
      formDataToSend.append("foodPreference", guestData.foodPreference || "");
      formDataToSend.append("allergic", guestData.allergic || "");
      formDataToSend.append("specialNeeds", guestData.specialNeeds || "");
      formDataToSend.append("specialRequest", guestData.specialRequest || "");
      formDataToSend.append("enteredBy", eventEntity.name || "anonymmousUser");
      formDataToSend.append("address", JSON.stringify(guestData.address));

      const url = isEditing ? updateGuest(editingGuestId) : addGuest();
      const method = isEditing ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          ...(getAuthToken()
            ? { Authorization: `Bearer ${getAuthToken()}` }
            : {}),
        },
        body: JSON.stringify({
          ...guestData,
          eventId: selectedEvent?.eventId || "",
        }),
      });

      if (response.ok) {
        toast.success(
          isEditing
            ? "Guest updated successfully!"
            : "Guest added successfully!"
        );
        setIsEditing(false);
        setEditingGuestId(null);
        setFieldErrors({});
        setGuestData(guestData); // Reset form

        getAllGuestByEventId(); // Refresh guest list
      } else {
        let errBody = {};
        try {
          errBody = JSON.parse(await response.text());
        } catch {
          errBody = {};
        }
        if (errBody.code === "CAPACITY_EXCEEDED") {
          setCapacityNotice({
            title: "Cannot exceed capacity",
            message: errBody.message,
          });
        } else {
          toast.error(errBody.message || "Failed to add/update guest.");
        }
      }
    } catch (error) {
      console.error("Error adding/updating guest:", error);
      toast.error("Failed to add/update guest.");
    }
  };

  const handleEditGuest = (guest) => {
    setIsEditing(true);
    setEditingGuestId(guest._id);
    setFieldErrors({});

    setGuestData({
      eventId: selectedEvent?.eventId || "",
      prefix: guest.prefix || "",
      firstName: guest.firstName || "",
      MiddleName: guest.MiddleName || "",
      lastName: guest.lastName || "",
      suffix: guest.suffix || "",
      gender: guest.gender || "",
      alternateMobileNo: guest.alternateMobileNo || "",
      email: guest.email || "",
      mobileNo: guest.mobileNo || "",
      addressType: guest.addressType || "",
      companyName: guest.companyName || "",
      designation: guest.designation || "",
      foodPreference: guest.foodPreference || "",
      allergic: guest.allergic || "",
      specialNeeds: guest.specialNeeds || "",
      specialRequest: guest.specialRequest || "",
      enteredBy: eventEntity.name || "anonymmousUser",
      address: guest.address || {
        line1: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
      },
    });
  };

  const handleCancel = () => {
    setGuestData(initialGuestData);
    setFieldErrors({});
    setIsEditing(false);
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(deleteGuest(deleteConfirmation.guestId), {
        method: "DELETE",
        headers: {
          ...(getAuthToken()
            ? { Authorization: `Bearer ${getAuthToken()}` }
            : {}),
        },
      });

      if (response.ok) {
        toast.success("Guest deleted successfully!");
        setDeleteConfirmation({ isOpen: false, guestId: null, guestName: "" });
        getAllGuestByEventId(); // Refresh guest list
      } else {
        const errorText = await response.text();
        toast.error("Failed to delete guest.");
        console.error("Delete failed:", errorText);
      }
    } catch (error) {
      console.error("Error deleting guest:", error);
      toast.error("Error deleting guest.");
    }
  };

  const handleAddEventClick = () => {
    setIsSidebarExpanded((prev) => !prev);
  };

  const getProgressWidth = () => {
    if (activeStep === 1) return "16%";
    if (activeStep === 2) return "50%";
    if (activeStep === 3) return "100%";
  };

  const [file, setFile] = useState(null);
  const [importing, setImporting] = useState(false);

  const closeImportModal = () => {
    setImportModal({ isOpen: false, report: null });
    setFile(null);
    setImporting(false);
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
  };

  const handleImport = async () => {
    if (!file) {
      toast.error("Please select an Excel file to import.");
      return;
    }

    if (peopleCap != null && peopleCount.total >= peopleCap) {
      setCapacityNotice({
        title: "Cannot exceed capacity",
        message: eventPeopleCapacityMessage({
          eventCapacity: peopleCap,
          currentTotal: peopleCount.total,
          adding: 1,
        }),
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("eventId", selectedEvent?.eventId || "");
    formData.append("enteredBy", eventEntity?.name || "adminUser");

    try {
      setImporting(true);
      const loadingToast = toast.loading("Uploading and processing...");
      const resp = await axios.post(importGuestsAndAttendees(), formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.dismiss(loadingToast);

      if (resp.data) {
        setImportModal({ isOpen: true, report: resp.data });
        setFile(null);
        getAllGuestByEventId();
        toast.success(
          `Imported ${resp.data.mainGuestCount || 0} guests and ${
            resp.data.attendeeCount || 0
          } attendees`
        );
      }
    } catch (err) {
      toast.dismiss();
      console.error(err);
      if (err.response?.data?.code === "CAPACITY_EXCEEDED") {
        setCapacityNotice({
          title: "Cannot exceed event capacity",
          message: capacityApiMessage(err),
        });
      } else {
        const msg =
          err.response?.data?.message || err.response?.data?.error || err.message;
        toast.error(`Import failed: ${msg}`);
      }
    } finally {
      setImporting(false);
    }
  };

  useEffect(() => {
    const fetchDropdownData = async (lookupId, setDropdown, errorMessage) => {
      try {
        const result = await getLookupUtils(lookupId);
        setDropdown(result.data);
      } catch (error) {
        console.error(errorMessage, error);
      }
    };
    fetchDropdownData("3", setPrefixDropdown, "Failed to fetch Prefix Data:");
    fetchDropdownData("19", setSuffixDropdown, "Failed to fetch Suffix Data:");
    fetchDropdownData("21", setStateDropdown, "Failed to fetch State Data:");
    fetchDropdownData(
      "22",
      setCountryDropdown,
      "Failed to fetch Country Data:"
    );
    fetchDropdownData(
      "8",
      setFoodPreference,
      "Failed to fetch Food Preference Data:"
    );
  }, []);

  const filteredGuests = guests.filter((guest) => {
    const fullName = `${guest.firstName || ""} ${guest.MiddleName || ""} ${
      guest.lastName || ""
    } ${guest.prefix || ""} ${guest.suffix || ""}`
      .toLowerCase()
      .trim();
    return fullName.includes(searchTerm.toLowerCase().trim());
  });

  const filteredGuestWithAttendees = guestWithAttendees.filter((entry) => {
    const search = searchTerm.toLowerCase().trim();

    const guest = entry.guest || {};
    const attendees = entry.attendees || [];

    const guestFullName = `${guest.firstName || ""} ${guest.middleName || ""} ${
      guest.lastName || ""
    }  ${guest.prefix || ""} ${guest.suffix || ""}`.toLowerCase();

    // Check if guest matches search
    if (guestFullName.includes(search)) return true;

    // Check if any attendee matches search
    const matchingAttendee = attendees.some((attendee) => {
      const attendeeFullName = `${attendee.firstName || ""} ${
        attendee.middleName || ""
      } ${attendee.lastName || ""}`.toLowerCase();
      return attendeeFullName.includes(search);
    });

    return matchingAttendee;
  });

  const downloadTemplate = () => {
    window.open(downloadGuestTemplate(), "_blank");
  };

  const renderFormOne = () => (
    <form id="guestForm">
      <div className="">
        <div className="row g-3">
          <h5 className="mb-1 event-inner-hed mt-2">Personal Details</h5>
          <hr />

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Prefix <span className="required-asterisk">*</span>
            </label>
            <select
              className={getFieldClass("form-select", "prefix")}
              name="prefix"
              value={guestData.prefix}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Prefix</option>
              {prefixDropdown.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
            {renderFieldError("prefix")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              First Name <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={getFieldClass("form-control", "firstName")}
              name="firstName"
              placeholder="Enter First Name"
              value={guestData.firstName}
              onChange={handleInputChange}
              required
            />
            {renderFieldError("firstName")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Middle Name <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={getFieldClass("form-control", "MiddleName")}
              name="MiddleName"
              placeholder="Middle name"
              value={guestData.MiddleName}
              onChange={handleInputChange}
              required
            />
            {renderFieldError("MiddleName")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Last Name <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={getFieldClass("form-control", "lastName")}
              name="lastName"
              placeholder="Enter Last Name"
              value={guestData.lastName}
              onChange={handleInputChange}
              required
            />
            {renderFieldError("lastName")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Suffix <span className="required-asterisk">*</span>
            </label>
            <select
              className={getFieldClass("form-select", "suffix")}
              name="suffix"
              placeholder="Enter Suffix"
              value={guestData.suffix}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Suffix</option>
              {suffixDropdown.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
            {renderFieldError("suffix")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Gender</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                value="Male"
                checked={guestData.gender === "Male"}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="male">
                Male
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                value="Female"
                checked={guestData.gender === "Female"}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="female">
                Female
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="gender"
                value="Other"
                checked={guestData.gender === "Other"}
                onChange={handleInputChange}
              />
              <label className="form-check-label" htmlFor="other">
                Other
              </label>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Mobile No. <span className="required-asterisk">*</span>
            </label>
            <input
              type="tel"
              className={getFieldClass("form-control", "mobileNo")}
              name="mobileNo"
              placeholder="Enter mobile number"
              value={guestData.mobileNo}
              onChange={handleInputChange}
              required
            />
            {renderFieldError("mobileNo")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Alternate Mobile No.</label>
            <input
              type="tel"
              className="form-control"
              name="alternateMobileNo"
              placeholder="Enter Alternate Number"
              value={guestData.alternateMobileNo}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Email <span className="required-asterisk">*</span>
            </label>
            <input
              type="email"
              className={getFieldClass("form-control", "email")}
              name="email"
              placeholder="Enter Email Id"
              value={guestData.email}
              onChange={handleInputChange}
              required
            />
            {renderFieldError("email")}
          </div>

          <h5 className="mb-4 event-inner-hed mt-3">Address</h5>
          <hr />
          <div className="col-md-8 mb-3">
            <label className="form-label">Address Type</label>
            <br />
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="addressType"
                value="office"
                checked={guestData.addressType === "office"}
                onChange={handleInputChange}
              />
              <label className="form-check-label" for="office">
                Office
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="addressType"
                value="residential"
                checked={guestData.addressType === "residential"}
                onChange={handleInputChange}
              />
              <label className="form-check-label" for="residential">
                Residential
              </label>
            </div>
          </div>

          {/* Show only if addressType is office */}
          {guestData.addressType === "office" && (
            <>
              <div className="col-md-6 mb-3">
                <label className="form-label">Company Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="companyName"
                  placeholder="Enter company name"
                  value={guestData.companyName}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Designation</label>
                <input
                  type="text"
                  className="form-control"
                  name="designation"
                  placeholder="Enter designation"
                  value={guestData.designation}
                  onChange={handleInputChange}
                />
              </div>
            </>
          )}

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Address Line 1 <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={getFieldClass("form-control", "line1")}
              name="line1"
              placeholder="Enter Line 1"
              value={guestData.address.line1}
              onChange={handleAddressChange}
              required
            />
            {renderFieldError("line1")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Line 2</label>
            <input
              type="text"
              className="form-control"
              name="line2"
              placeholder="Enter Line 2"
              value={guestData.address.line2}
              onChange={handleAddressChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Line 3</label>
            <input
              type="text"
              className="form-control"
              name="line3"
              placeholder="Enter Line 3"
              value={guestData.address.line3}
              onChange={handleAddressChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              City <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={getFieldClass("form-control", "city")}
              name="city"
              placeholder="Enter City"
              value={guestData.address.city}
              onChange={handleAddressChange}
              required
            />
            {renderFieldError("city")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">State </label>

            <select
              className="form-select"
              name="state"
              value={guestData.address.state}
              onChange={handleAddressChange}
            >
              <option value="">Select State</option>
              {stateDropdown.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">
              Pincode <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={getFieldClass("form-control", "pincode")}
              name="pincode"
              placeholder="Enter Pincode"
              value={guestData.address.pincode}
              onChange={handleAddressChange}
              required
            />
            {renderFieldError("pincode")}
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Country</label>

            <select
              className="form-select"
              name="country"
              value={guestData.address.country}
              onChange={handleAddressChange}
            >
              <option value="">Select Country</option>
              {countryDropdown.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
          </div>

          <h5 className="mb-4 event-inner-hed mt-3">Preferences</h5>
          <hr />

          <div className="col-md-6 mb-3">
            <label className="form-label">Food Preference</label>
            <select
              className="form-select"
              name="foodPreference"
              value={guestData.foodPreference}
              onChange={handleInputChange}
            >
              <option value="">Select Food Preference</option>
              {foodPreference.map((item) => (
                <option key={item._id} value={item.Lookup_Value_Code}>
                  {item.Lookup_Value_Name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Allergic</label>
            <input
              type="text"
              className="form-control"
              name="allergic"
              placeholder="Enter allergic details"
              value={guestData.allergic}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Special Needs</label>
            <textarea
              className="form-control"
              name="specialNeeds"
              placeholder="Enter allergy details if any"
              value={guestData.specialNeeds}
              onChange={handleInputChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Special Request</label>
            <textarea
              className="form-control"
              name="specialRequest"
              placeholder="Enter special request if any"
              value={guestData.specialRequest}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>
      {/* <hr /> */}

    </form>
  );



  const getStepContent = (step) => {
    switch (step) {
      case 1:
        return (
          <>
            {/* <h5>Add Main Guest</h5> */}
            {renderFormOne()}
          </>
        );
      
      default:
        return <div>Invalid Step</div>;
    }
  };

  const shouldExpand =
    !canEdit ? !isSidebarExpanded : isSidebarExpanded;

  return (
    <>
      <div className="container-fluid GuestAttendee">
        <div className="">
          <div
            className={`occasion-top occasion-top-with-sidebar row g-4 align-items-center${
              isSidebarExpanded ? " expanded-sidebar" : ""
            }${
              !canEdit
                ? " expanded-sidebar-role-viewer"
                : ""
            }`}
          >
            <div className="col-lg-9">
              <h2 className="mb-0">Guest Master</h2>
            </div>
            <div className="col-lg-3 occasion-top-search-col">
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Search Guest..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div
          className={`row g-4 
    ${isSidebarExpanded ? "expanded-sidebar" : ""} 
    ${!canEdit ? "expanded-sidebar-role-viewer" : ""}`}
        >
          {canEdit && (
            <div className="col-lg-9" id="formColumn">
              <div className="form-section">
                <div className="all-page-scroll vh80">
                  <div className="progress-container position-relative mb-3">
                    <div className="progress-line">
                      <div
                        className="progress-fill"
                        style={{ width: getProgressWidth() }}
                      ></div>
                    </div>

                    <div className="d-flex justify-content-between">
                      {[1, 2, 3].map((step) => (
                        <div
                          key={step}
                          className={`step text-center ${
                            activeStep >= step ? "active" : ""
                          }`}
                          onClick={() => setActiveStep(step)}
                        >
                          <div className="circle">{step}</div>
                          <div className="label">
                            {step === 1
                              ? "Add Main Guest"
                              : step === 2
                              ? "Accommodation"
                              : "Travel Details"}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="step-content p-4">
                    {getStepContent(activeStep)}
                  </div>
                </div>
                <hr />
              <div className="mt-4 d-flex justify-content-end gap-2 justify-content-center py-3">
        <button
          type="button"
          form="guestForm"
          className="btn btn-success btn-save"
          onClick={handleSubmit}
        >
          {isEditing ? "Update" : "Save "}
        </button>
        <button
          type="reset"
          className="btn btn-outline-secondary btn-cancel"
          onClick={handleCancel}
        >
          Cancel
        </button>
      </div>
              </div>
            </div>
          )}
          <div
            className="col-lg-3"
            id={
              !canEdit
                ? "sidebarColumnRoleviewer"
                : "sidebarColumn"
            }
          >
            <div className="event-sidebar">
              {/* <div className="d-flex justify-content-between align-items-center mb-3">
                <h6>All Guest</h6>

                
              </div> 
              <hr />*/}
               <div className="guest-list-toolbar">
                <ul
                  className="nav nav-tabs mb-0"
                  id="guestsTabs"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link${
                        activeTab === "guestList" ? " active" : ""
                      }`}
                      id="guestList-tab"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "guestList"}
                      onClick={() => setActiveTab("guestList")}
                    >
                      Guest List
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link${
                        activeTab === "guestAndAttendeeList" ? " active" : ""
                      }`}
                      id="guestAndAttendeeList-tab"
                      type="button"
                      role="tab"
                      aria-selected={activeTab === "guestAndAttendeeList"}
                      onClick={() => setActiveTab("guestAndAttendeeList")}
                    >
                      Guest-Attendee List
                    </button>
                  </li>
                </ul>
                <button
                  type="button"
                  className="guest-sidebar-toggle"
                  onClick={handleAddEventClick}
                  title={isSidebarExpanded ? "Collapse list" : "Expand list"}
                  aria-label={isSidebarExpanded ? "Collapse list" : "Expand list"}
                >
                  <i
                    className={`bi ${
                      isSidebarExpanded ? "bi-chevron-right" : "bi-chevron-left"
                    }`}
                  ></i>
                </button>
               </div>

                <hr />

              <div className="all-page-right-scroll gm-right-scroll">
                {/* Tabs */}
               
                <div className="tab-content" id="eventTabsContent">
                  {/* Guest List Tab */}

                  <div
                    className={`tab-pane fade ${
                      activeTab === "guestList" ? "show active" : ""
                    }`}
                    id="guestList"
                  >
                    {shouldExpand ? (
                      <>
                        {" "}
                        <div className="">
                          <div className="table-responsive">
                            <table className="table">
                              <thead className="thead-dark table-bordered table-hover table-bg-new">
                                <tr>
                                  <th>#</th>
                                  <th>Guest Name</th>
                                  <th>Gender</th>
                                  <th>Allergy</th>
                                  <th>Special Needs</th>
                                  <th>
                                    {canEdit && "Action"}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredGuests.map((guest, index) => (
                                  <tr key={guest._id || index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {guest.prefix} {guest.firstName}{" "}
                                      {guest.MiddleName} {guest.lastName}{" "}
                                      {guest.suffix}
                                    </td>
                                    <td>{guest.gender || "-"}</td>
                                    <td>
                                      {guest.allergic ? guest.allergic : ""}
                                    </td>
                                    {/* <td>{guest.allergic ? 'Allergy' : 'No Allergy'}</td> */}
                                    <td>
                                      {guest.specialNeeds
                                        ? guest.specialNeeds
                                        : ""}
                                    </td>
                                    <td>
                                      {canEdit && (
                                        <>
                                          <a
                                            href="#"
                                            className="btn edit-btn me-2"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleEditGuest(guest); // pass the current guest object
                                            }}
                                          >
                                            Edit
                                          </a>
                                          {canDelete && (
                                            <a
                                              href="#"
                                              className="btn btn-danger me-2"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                setDeleteConfirmation({
                                                  isOpen: true,
                                                  guestId: guest._id,
                                                  guestName: `${guest.firstName} ${guest.MiddleName} ${guest.lastName}`,
                                                });
                                              }}
                                            >
                                              Delete
                                            </a>
                                          )}
                                          <a
                                            href="#"
                                            className="btn attendee-btn"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleAddAttendee(guest); // pass the current guest object
                                            }}
                                          >
                                            Add Attendee
                                          </a>
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {" "}
                        <div className="list-side-stack">
                          {filteredGuests.map((guest, index) => (
                            <div
                              className="event-card list-side-card"
                              key={guest._id || index}
                            >
                              <div className="list-side-card-title">
                                {[
                                  guest.prefix,
                                  guest.firstName,
                                  guest.MiddleName,
                                  guest.lastName,
                                  guest.suffix,
                                ]
                                  .filter(Boolean)
                                  .join(" ")}
                              </div>
                              <div className="list-side-card-meta">
                                <span>
                                  <em>Gender</em>
                                  {guest.gender || "—"}
                                </span>
                                <span>
                                  <em>Allergy</em>
                                  {guest.allergic ? guest.allergic : "None"}
                                </span>
                                <span>
                                  <em>Needs</em>
                                  {guest.specialNeeds
                                    ? guest.specialNeeds
                                    : "None"}
                                </span>
                              </div>
                              {canEdit && (
                                <div className="list-side-card-actions event-actions">
                                  <a
                                    href="#"
                                    className="btn edit-btn"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleEditGuest(guest);
                                    }}
                                  >
                                    Edit
                                  </a>

                                  {canDelete && (
                                    <a
                                      href="#"
                                      className="btn btn-danger"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setDeleteConfirmation({
                                          isOpen: true,
                                          guestId: guest._id,
                                          guestName: `${guest.firstName} ${guest.MiddleName} ${guest.lastName}`,
                                        });
                                      }}
                                    >
                                      Delete
                                    </a>
                                  )}
                                  <a
                                    href="#"
                                    className="btn attendee-btn"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleAddAttendee(guest);
                                    }}
                                  >
                                    Add Attendee
                                  </a>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>

                  {/* guestAndAttendeeList Tab */}
                  <div
                    className={`tab-pane fade ${
                      activeTab === "guestAndAttendeeList" ? "show active" : ""
                    }`}
                    id="guestAndAttendeeList"
                  >
                    {shouldExpand ? (
                      <>
                        <div className="">
                          <div className="table-responsive">
                            <table className="table">
                              <thead className="thead-dark table-bordered table-hover table-bg-new">
                                <tr>
                                  <th>Sr&nbsp;No.</th>
                                  <th>Guest/Attendee Name</th>
                                  <th>Relation</th>
                                  <th>Gender</th>
                                  <th>Allergy</th>
                                  <th>Special Needs</th>
                                  <th>
                                    {canEdit && "Action"}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredGuestWithAttendees.map(
                                  (entry, index) => {
                                    const guest = entry.guest;
                                    const attendees = entry.attendees || [];

                                    return (
                                      <React.Fragment key={guest._id || index}>
                                        {/* Main Guest Row */}
                                        <tr className="table-primary">
                                          <td>{index + 1}</td>
                                          <td>
                                            {guest.prefix} {guest.firstName}{" "}
                                            {guest.middleName} {guest.lastName}{" "}
                                            {guest.suffix}
                                          </td>
                                          <td>-</td>

                                          <td>{guest.gender || "-"}</td>
                                          <td>{guest.allergic || ""}</td>
                                          <td>{guest.specialNeeds || ""}</td>
                                          <td>
                                            {canEdit && (
                                              <>
                                                <a
                                                  href="#"
                                                  className="text-primary edit-btn me-2"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    handleEditGuest(guest);
                                                  }}
                                                >
                                                  Edit
                                                </a>
                                                {canDelete && (
                                                  <a
                                                    href="#"
                                                    className="text-danger btn-danger round"
                                                  >
                                                    Delete
                                                  </a>
                                                )}
                                              </>
                                            )}
                                          </td>
                                        </tr>

                                        {/* Attendees Rows */}
                                        {attendees.map((attendee, i) => (
                                          <tr
                                            key={attendee._id}
                                            className="table-secondary"
                                          >
                                            <td>{`${index + 1}.${i + 1}`}</td>
                                            <td>
                                              {attendee.prefix}{" "}
                                              {attendee.firstName}{" "}
                                              {attendee.middleName}{" "}
                                              {attendee.lastName}{" "}
                                              {attendee.suffix}
                                            </td>
                                            <td>
                                              {attendee.relationWithMainMember ||
                                                "N/A"}
                                            </td>

                                            <td>{attendee.gender || "-"}</td>
                                            <td>{attendee.allergic || ""}</td>
                                            <td>
                                              {attendee.specialNeeds || ""}
                                            </td>
                                            <td>
                                              {/* Optional Edit/Delete for attendee */}
                                            </td>
                                          </tr>
                                        ))}
                                      </React.Fragment>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {" "}
                        <div className="event-list-scroll list-side-stack">
                          {filteredGuestWithAttendees.map((entry, index) => {
                            const guest = entry.guest;
                            const attendees = entry.attendees || [];

                            return (
                              <div
                                className="event-card list-side-card"
                                key={guest._id || index}
                              >
                                <div className="list-side-card-title">
                                  {[
                                    guest.prefix,
                                    guest.firstName,
                                    guest.middleName,
                                    guest.lastName,
                                    guest.suffix,
                                  ]
                                    .filter(Boolean)
                                    .join(" ")}
                                </div>
                                {canEdit && (
                                  <div className="list-side-card-actions event-actions">
                                    <a
                                      href="#"
                                      className="btn edit-btn"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleEditGuest(guest);
                                      }}
                                    >
                                      Edit
                                    </a>

                                    {canDelete && (
                                      <a
                                        href="#"
                                        className="btn btn-danger"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setDeleteConfirmation({
                                            isOpen: true,
                                            guestId: guest._id,
                                            guestName: `${guest.firstName} ${guest.middleName} ${guest.lastName}`,
                                          });
                                        }}
                                      >
                                        Delete
                                      </a>
                                    )}

                                    <a
                                      href="#"
                                      className="btn attendee-btn"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleAddAttendee(guest);
                                      }}
                                    >
                                      Add Attendee
                                    </a>
                                  </div>
                                )}
                                {attendees.length > 0 && (
                                  <div className="list-side-card-sub">
                                    <span className="list-side-card-sub-title">
                                      Attendees ({attendees.length})
                                    </span>
                                    <div className="list-side-card-sub-list">
                                      {attendees.map((attendee, i) => (
                                        <div
                                          key={attendee._id || i}
                                          className="list-side-card-sub-item"
                                        >
                                          <strong>
                                            {i + 1}.{" "}
                                            {[
                                              attendee.prefix,
                                              attendee.firstName,
                                              attendee.middleName,
                                              attendee.lastName,
                                              attendee.suffix,
                                            ]
                                              .filter(Boolean)
                                              .join(" ")}
                                          </strong>
                                          <small>
                                            Relation:{" "}
                                            {attendee.relationWithMainMember ||
                                              "N/A"}
                                          </small>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {canEdit && (
                <div className="guest-sidebar-actions">
                  <button
                    type="button"
                    className="btn guest-sidebar-action-btn is-import"
                    onClick={() => setImportModal({ isOpen: true, report: null })}
                  >
                    <i className="bi bi-upload" aria-hidden="true" />
                    Import Guests
                  </button>
                  <button
                    type="button"
                    className="btn guest-sidebar-action-btn is-template"
                    onClick={downloadTemplate}
                  >
                    <i className="bi bi-file-earmark-arrow-down" aria-hidden="true" />
                    Download Template
                  </button>
                  <button
                    type="button"
                    className="btn guest-sidebar-action-btn is-export"
                    onClick={handleGuestAndAttendeeExport}
                  >
                    <i className="bi bi-file-earmark-excel" aria-hidden="true" />
                    Export to Excel
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {deleteConfirmation.isOpen && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() =>
                      setDeleteConfirmation({
                        isOpen: false,
                        guestId: null,
                        guestName: "",
                      })
                    }
                  ></button>
                </div>
                <div className="modal-body">
                  <p>
                    Are you sure you want to delete guest:{" "}
                    <strong>{deleteConfirmation.guestName}</strong>?
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary cancel-btn"
                    onClick={() =>
                      setDeleteConfirmation({
                        isOpen: false,
                        guestId: null,
                        guestName: "",
                      })
                    }
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {importModal.isOpen && (
          <div
            className="modal fade show guest-import-modal"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            aria-labelledby="guest-import-title"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content guest-import-panel">
                <div className="modal-header guest-import-header">
                  <h5 className="modal-title" id="guest-import-title">
                    {importModal.report
                      ? "Import results"
                      : "Import guests from Excel"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={closeImportModal}
                  />
                </div>

                <div className="modal-body guest-import-body">
                  {!importModal.report ? (
                    <>
                      <div className="guest-import-drop">
                        <i
                          className="bi bi-file-earmark-excel guest-import-drop-icon"
                          aria-hidden="true"
                        />
                        <div className="guest-import-drop-copy">
                          <strong>
                            {file ? file.name : "Choose an Excel file"}
                          </strong>
                          <span>
                            {file
                              ? `${Math.max(1, Math.round(file.size / 1024))} KB selected`
                              : "Accepted formats: .xlsx, .xls"}
                          </span>
                        </div>
                        <label className="btn guest-import-browse">
                          Browse
                          <input
                            type="file"
                            accept=".xlsx,.xls"
                            className="d-none"
                            onChange={handleFileChange}
                          />
                        </label>
                      </div>

                      <ul className="guest-import-tips">
                        <li>
                          Column A: <strong>Guest</strong> or{" "}
                          <strong>Attendee</strong>
                        </li>
                        <li>
                          Attendee rows must follow their main guest row
                        </li>
                        <li>First Name and Last Name are required</li>
                      </ul>
                    </>
                  ) : (
                    <>
                      <div className="guest-import-summary">
                        <div className="guest-import-stat">
                          <span>Rows processed</span>
                          <strong>
                            {importModal.report.totalProcessed ?? 0}
                          </strong>
                        </div>
                        <div className="guest-import-stat is-success">
                          <span>Main guests saved</span>
                          <strong>
                            {importModal.report.mainGuestCount ?? 0}
                          </strong>
                        </div>
                        <div className="guest-import-stat is-success">
                          <span>Attendees saved</span>
                          <strong>
                            {importModal.report.attendeeCount ?? 0}
                          </strong>
                        </div>
                        <div
                          className={`guest-import-stat${
                            (importModal.report.errors || []).length
                              ? " is-warn"
                              : ""
                          }`}
                        >
                          <span>Issues found</span>
                          <strong>
                            {(importModal.report.errors || []).length}
                          </strong>
                        </div>
                      </div>

                      <p className="guest-import-result-note mb-0">
                        {(importModal.report.successCount ??
                          (importModal.report.mainGuestCount || 0) +
                            (importModal.report.attendeeCount || 0)) > 0
                          ? "Import finished. Saved records are already in the guest list."
                          : "No records were saved. Review the issues below and fix the file."}
                      </p>

                      {(importModal.report.errors || []).length > 0 && (
                        <div className="guest-import-errors">
                          <h6>What needs attention</h6>
                          <div className="guest-import-errors-scroll">
                            <table className="table table-sm mb-0">
                              <thead>
                                <tr>
                                  <th>Cell</th>
                                  <th>Issue</th>
                                </tr>
                              </thead>
                              <tbody>
                                {importModal.report.errors.map((err, idx) => (
                                  <tr key={`${err.cell || err.row}-${idx}`}>
                                    <td>
                                      <code>
                                        {err.cell || `Row ${err.row}`}
                                      </code>
                                    </td>
                                    <td>
                                      {err.message ||
                                        (Array.isArray(err.issues)
                                          ? err.issues.join(" · ")
                                          : "Validation error")}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="modal-footer guest-import-footer">
                  <button
                    type="button"
                    className="btn guest-import-cancel"
                    onClick={closeImportModal}
                  >
                    {importModal.report ? "Done" : "Cancel"}
                  </button>

                  {!importModal.report && (
                    <button
                      type="button"
                      className="btn guest-import-submit"
                      disabled={!file || importing}
                      onClick={handleImport}
                    >
                      {importing ? "Importing…" : "Import file"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <CapacityNoticeModal
          open={Boolean(capacityNotice)}
          title={capacityNotice?.title}
          message={capacityNotice?.message}
          onClose={() => setCapacityNotice(null)}
        />
      </div>
    </>
  );
};

export default GuestMaster;
